import { AdspDetails, Commission, Organization, PrimaryAdmin, QlikSettings, TdspDetails } from "./user";

export class Advertiser {
  name: string;
  currency;
  msa_date;
  msa_id:string;
  msa_entity:string;
  sameBillingAddress:boolean;
  creator: 'self' | 'admin';
  timezone;
  management_type: 'self' | 'managed';
  state: 'active' | 'on_hold' | 'paused' | 'suspended' | 'rejected';
  primary_admin: PrimaryAdmin;
  organization: Organization;
  adsp_details: AdspDetails;
  apnx_commission: Commission;
  config: Config;
  vertical: 'political' | 'general';
  tier: 'professional' | 'lite';
  adsp_enabled: boolean;
  apnx_enabled: boolean;
  bdsp_enabled: boolean;
  tdsp_enabled: boolean;
  dco_enabled: boolean;
  cdp_enabled: boolean;
  adsp_id: String;
  adsp_region: string;
  adsp_target_country: string;
  bdsp_category: string;
  tdsp_details: TdspDetails;

  constructor() {
    this.sameBillingAddress =true;
    this.adsp_enabled = false;
    this.apnx_enabled = false;
    this.bdsp_enabled = false;
    this.cdp_enabled = false;
    this.tdsp_enabled = false;
    this.dco_enabled = false;
    this.msa_entity = "US"
    this.vertical = 'political';
    this.management_type = 'self';
    this.vertical = 'general';
    this.tier = 'professional'
    this.state = 'on_hold';
    this.currency = 'USD';
    this.creator =  'admin';
    this.timezone = 'EST5EDT';
    this.adsp_region = "US";
    this.adsp_target_country = "united_states";
    this.primary_admin = new PrimaryAdmin();
    this.organization = new Organization();
    this.apnx_commission = new Commission();
    this.config = new Config();
    this.adsp_details = new AdspDetails();
    this.tdsp_details =  new TdspDetails();
  }
}

export class DefaultAdvertiser{
  currency
  allow_creative_3rd_party_pixels
  allow_creative_html_tags
  allow_bdsp_creative_3rd_party_pixels
  allow_bdsp_creative_html_tags
  allow_bdsp_creative_vast_tags
  allow_tdsp_creative_3rd_party_pixels
  allow_tdsp_creative_html_tags
  allow_tdsp_creative_vast_tags
  allow_creative_vast_tags
  show_seg_upload_history
  burn_rate_check
  chatbot_enabled
  contract_commission
  credit_limit
  flight_budget_limit
  minimum_daily_budget
  freq_cap_day_limit
  freq_cap_hour_limit
  freq_cap_lifetime_limit
  freq_cap_month_limit
  freq_cap_week_limit
  management_type
  min_commission
  notification_amount
  show_account_statement
  show_seg_upload_stats
  enable_data_uploads
  enable_adsp_data_file_download
  enable_data_conversion
  show_sensitive_metrics
  enable_auto_optimization
  enable_offline_attribution
  show_tdsp_seg_upload_stats
  allow_tdsp_predective_clearing
  allow_tdsp_koa_audiences
  allow_tdsp_apac_ph_no_upload
  allow_tdsp_temperature_targeting
  allow_tdsp_viooh
  allow_tdsp_weather_targeting
  system_commission
  run_netflix_ads
  apnx_netflix_activation_state
  vertical
  constructor(){ }
}

export class Config {
  show_account_statement: boolean;
  notification_amount: number;
  credit_limit: number;
  min_commission:number;
  allow_creative_html_tags: boolean;
  allow_bdsp_creative_html_tags: boolean;
  allow_bdsp_creative_vast_tags: boolean;
  allow_tdsp_creative_3rd_party_pixels: boolean;
  allow_tdsp_creative_html_tags: boolean;
  allow_tdsp_creative_vast_tags: boolean;
  show_tdsp_seg_upload_stats: boolean;
  allow_tdsp_predective_clearing: boolean;
  allow_tdsp_koa_audiences: boolean;
  allow_tdsp_viooh: boolean;
  allow_tdsp_weather_targeting: boolean;
  allow_tdsp_temperature_targeting: boolean;
  allow_tdsp_apac_ph_no_upload: boolean;
  enable_tdsp_click_pacing: boolean;
  enable_tdsp_macro_id: boolean;
  allow_creative_vast_tags: boolean;
  show_sensitive_metrics: boolean;
  allow_creative_3rd_party_pixels: boolean;
  allow_bdsp_creative_3rd_party_pixels: boolean;
  enable_data_uploads: boolean;
  enable_data_conversion: boolean;
  enable_adsp_pg_deals: boolean;
  enable_adsp_data_file_download: boolean;
  show_seg_upload_stats: boolean;
  enable_auto_optimization: boolean;
  enable_offline_attribution: boolean;
  burn_rate_check: boolean;
  chatbot_enabled: boolean;
  override_msa_check: boolean;
  flight_budget_limit: number;
  minimum_daily_budget: number;
  freq_cap_hour_limit: number;
  freq_cap_day_limit: number;
  freq_cap_week_limit: number;
  freq_cap_month_limit: number;
  freq_cap_lifetime_limit: number;
  minimum_msf: number;
  maximum_msf: number;
  msf_pct: number;
  qlik_enabled: boolean;
  qlik_settings: QlikSettings;
  run_netflix_ads: boolean;
  apnx_netflix_activation_state: 'active' | 'inactive';

  constructor() {
    // this.show_account_balance = true;
    this.show_account_statement = false;
    this.allow_creative_html_tags = false;
    this.allow_bdsp_creative_html_tags = false;
    this.allow_creative_vast_tags = false;
    this.allow_bdsp_creative_vast_tags = false;
    this.allow_tdsp_creative_3rd_party_pixels = false;
    this.allow_tdsp_creative_html_tags = false;
    this.allow_tdsp_creative_vast_tags = false;
    this.allow_creative_3rd_party_pixels = false;
    this.allow_bdsp_creative_3rd_party_pixels = false;
    this.override_msa_check = false;
    this.show_sensitive_metrics = false;
    this.enable_data_conversion = false;
    this.enable_adsp_pg_deals = false;
    this.enable_adsp_data_file_download = true;
    this.enable_data_uploads = false;
    this.enable_auto_optimization = false;
    this.enable_offline_attribution = false;
    this.allow_tdsp_predective_clearing = false;
    this.allow_tdsp_koa_audiences = false;
    this.allow_tdsp_temperature_targeting = false;
    this.allow_tdsp_weather_targeting =  false;
    this.allow_tdsp_apac_ph_no_upload = false;
    this.show_tdsp_seg_upload_stats = false;
    this.show_seg_upload_stats = false;
    this.allow_tdsp_viooh = false;
    this.burn_rate_check = false;
    this.chatbot_enabled = false;
    this.flight_budget_limit = 10000;
    this.minimum_daily_budget = 10;
    this.freq_cap_hour_limit = 5;
    this.freq_cap_day_limit = 20;
    this.freq_cap_week_limit = 50;
    this.freq_cap_month_limit = 100;
    this.freq_cap_lifetime_limit = 255;
    this.minimum_msf = 0;
    this.maximum_msf = 0;
    this.msf_pct = 10;
    this.qlik_enabled = false;
    this.qlik_settings = new QlikSettings();
    this.run_netflix_ads = false;
    this.apnx_netflix_activation_state = 'inactive';
    this.enable_tdsp_click_pacing = false;
    this.enable_tdsp_macro_id = false;
  }
}

export const ClientTier: Array<any> = [
  { 'label': 'General', 'value': 'general' },
  { 'label': 'Political', 'value': 'political' },
]

export const DspAccess: Array<any> = [
  { 'label': 'Amazon Dsp', 'value': 'amazon_dsp' },
  { 'label': 'Vizibl Dsp', 'value': 'vizibl_dsp' },
]

export const IndustryOptions: Array<any> = [
  { 'label': 'Automotive', 'value': 'automotive' },
  { 'label': 'Consumer Goods', 'value': 'consumer_goods' },
  { 'label': 'eCommerce', 'value': 'ecommerce' },
  { 'label': 'Entertainment', 'value': 'entertainment' },
  { 'label': 'Financial Services', 'value': 'financial_services' },
  { 'label': 'Hardware & Electronics', 'value': 'hardware_electronics' },
  { 'label': 'Health', 'value': 'health' },
  { 'label': 'House Ads', 'value': 'house_ads' },
  { 'label': 'Public Services', 'value': 'public_services' },
  { 'label': 'Retail Goods & Services', 'value': 'retail_goods' },
  { 'label': 'Software', 'value': 'software' },
  { 'label': 'Telecommunications', 'value': 'telecom' },
  { 'label': 'Travel', 'value': 'travel' },
  { 'label': 'Web Media', 'value': 'web_media' },
]

export const OfflineEntryTypes: Array<any> = [
  { 'label': 'Percentage on Media Cost', 'value': 'percentage_on_mc' },
  { 'label': 'Value on CPM', 'value': 'value_on_cpm' },
]
